import { Component } from "./Component";
import { vp } from "../managers/vp";
import { DataUtils } from "socios-tools/utils/DataUtils";
import { DomUtils } from "socios-tools/utils/DomUtils";
export class NavListItem extends Component {
    constructor() {
        super(...arguments);
        this._listOpen = false;
        this._listItems = [];
        this.onHrefClick = () => {
            if (this._id > -1) {
                vp.localStorageData.menu.current = this._id;
            }
        };
        this.updateList = () => {
            if (this._listHtml) {
                this.html.setAttribute('data-list', this._listOpen ? 'open' : 'close');
                this._listHtml.style.height = this._listOpen ? this._listHtml.scrollHeight + 'px' : '0';
            }
        };
    }
    get isCurrentUrl() {
        return this._isCurrentUrl;
    }
    get id() {
        return this._id;
    }
    init() {
        this._arrowBtn = this.getHtml('arrow');
        this._listHtml = this.getHtml('list', null, true);
        this._headHtml = this.getHtml('head');
        this._labelHtml = this.getHtml('label');
        this._isCurrentUrl = DataUtils.parseBoolean(this.html.getAttribute('data-is-current-url'));
        this._id = Number(this.html.getAttribute('data-id')) || -1;
        if (this._labelHtml.hasAttribute('href')) {
            this._labelHtml.addEventListener('click', this.onHrefClick);
        }
    }
    getWasPreviouslyOpened() {
        return this._labelHtml.textContent ? !!vp.localStorageData.menu.opened[this._labelHtml.textContent] : false;
    }
    onNavListComplete() {
        if (this._listHtml && this._listHtml.children.length > 0) {
            this.activateList();
        }
    }
    activateList() {
        this._listItems = DomUtils.map(this._listHtml.children, (listItem) => {
            return vp.components.getByHTML(listItem);
        });
        this._arrowBtn.style.display = 'block';
        let menuClickHtml;
        if (this._labelHtml.hasAttribute('href')) {
            menuClickHtml = this._arrowBtn;
        }
        else {
            menuClickHtml = this._headHtml;
        }
        menuClickHtml.addEventListener('click', () => {
            this.toggleList();
        });
        this.updateList();
        this._listHtml.style.transition = 'height ease .2s';
    }
    toggleList() {
        if (this._listHtml && this._listHtml.children.length > 0) {
            this._listOpen = !this._listOpen;
            this.updateList();
            if (this._labelHtml.textContent) {
                vp.localStorageData.menu.opened[this._labelHtml.textContent] = this._listOpen;
            }
        }
    }
    hasCurrentPageItem() {
        return this._listItems.some((listItem) => {
            return listItem.isCurrentPage || listItem.hasCurrentPageItem();
        });
    }
    openList() {
        if (this._listHtml && this._listHtml.children.length > 0) {
            this._listOpen = true;
            this.updateList();
        }
    }
    closeList() {
        if (this._listHtml && this._listHtml.children.length > 0) {
            this._listOpen = false;
            this.updateList();
        }
    }
    get isCurrentPage() {
        return this._isCurrentPage;
    }
    set isCurrentPage(value) {
        this._isCurrentPage = value;
        this.html.setAttribute('data-current', value ? 'True' : 'False');
    }
}
